import { tomorrowAt } from 'owa-locstrings/lib/strings/tomorrowat.locstring.json';
import { todayAt } from 'owa-locstrings/lib/strings/todayat.locstring.json';
import { inXMinutes } from 'owa-locstrings/lib/strings/inxminutes.locstring.json';
import { now as now_1 } from 'owa-locstrings/lib/strings/now.locstring.json';
import loc, { format } from 'owa-localize';
import { CalendarEvent } from 'owa-calendar-types';
import { MILLISECONDS_IN_MINUTE } from 'owa-date-constants';
import { formatUserTime, isSameDay, userDate } from 'owa-datetime';
import { isUpNextEventHappeningNow } from 'owa-datetime-utils';
import { observableNow } from 'owa-observable-datetime';

const MILLISECONDS_IN_TWENTY_MINUTES = 20 * MILLISECONDS_IN_MINUTE;

export default function getTimeUntilEvent(upNextEvent: CalendarEvent): string {
    const now = observableNow();

    /**
     * Case 1 - Show "Now" when event is happening now
     */

    if (isUpNextEventHappeningNow(now, upNextEvent.Start, upNextEvent.End)) {
        return loc(now_1);
    }

    /**
     * Case 2 - Show "in {0} mins" when event is 20 mins away from now
     */
    const meetingStart = userDate(upNextEvent.Start);
    const differenceInSeconds = Math.abs(now.getTime() - meetingStart.getTime());
    if (differenceInSeconds <= MILLISECONDS_IN_TWENTY_MINUTES) {
        const minutes = Math.ceil(differenceInSeconds / MILLISECONDS_IN_MINUTE);
        return format(loc(inXMinutes), minutes);
    }

    /**
     * Case 3 - Event is today after 20 mins from now or tomorrow
     */
    const isMeetingToday = isSameDay(now, meetingStart);
    const timeStringFormat = isMeetingToday
            ? loc(todayAt) /* at {0} */
            : loc(tomorrowAt) /* Tomorrow at {0} */;

    return format(timeStringFormat, formatUserTime(meetingStart));
}
